import DashboardCard from "./DashboardCard";
import {BsPerson} from "react-icons/bs";
import styles from "../../styles/Components/new-dashboard/AccountSummary.module.css";
import useFetchReferralRewards from "../../hooks/api/useFetchReferralRewards";
import AccountBalance from "./account-summary/AccountBalance";
import ReferralEarnings from "./account-summary/ReferralEarnings";
import SubscriptionStatus from "./account-summary/SubscriptionStatus";
import ActiveServices from "./account-summary/ActiveServices";
import AccountSummaryPreview from "./account-summary/AccountSummaryPreview";

function AccountSummary() {
  // const {
  //   pricingPlan: { referralRewardsLoading },
  //   main: { userData },
  //   profile: { loading },
  // } = useSelector((state) => state);

  // const dataLoading = referralRewardsLoading || loading;
  //
  // const dispatch = useDispatch();

  // fetch referral rewards
  useFetchReferralRewards();

  // const refreshHandler = () => {
  //   if (dataLoading) return;
  //
  //   dispatch(
  //     getProfileData(userData?.email, userData?.["custom:custom_username"]),
  //   );
  //   dispatch(
  //     getReferralRewards(userData?.email, userData?.["custom:custom_username"]),
  //   );
  // };

  return (
    <DashboardCard
      title="Account Summary"
      titleIcon={<BsPerson size={20} />}
      preview={<AccountSummaryPreview />}
      bodyClassName={styles.contentWrapper}
      // actions={
      //   <CustomButton loading={dataLoading} onClick={refreshHandler}>
      //     {!dataLoading && <MdRefresh />}
      //     Refresh
      //   </CustomButton>
      // }
      type="accountSummary"
    >
      <AccountBalance />

      <ReferralEarnings />

      <SubscriptionStatus />

      <ActiveServices />
    </DashboardCard>
  );
}

export default AccountSummary;
